<template>
  <div>
    <!-- 操作 -->
    <div class="operate">
      <!--全选  -->
      <el-checkbox v-model="$parent.checked" @change="allChecked">
        {{ $t("message.allChecked") }}
      </el-checkbox>
      <!-- 打印清单 -->
      <el-button size="small" type="primary" @click="printList">{{ $t("message.printList") }}
      </el-button>
      <!-- 配货打印唛头 -->
      <el-button size="small" type="primary" class="secondary" @click="shippingMarkForDistribution">
        {{ $t("message.shippingMarkForDistribution") }}
      </el-button>
      <!-- 打印装箱单 -->
      <el-button size="small" type="success" @click="printPackingList('')">
        {{ $t("message.printPackingList") }}
      </el-button>
      <!-- 打印装箱单(无单价)-->
      <el-button size="small" type="success" @click="printPackingList('NoPrice')">
        {{ $t("message.printPackingListNoPrice") }}
      </el-button>
      <!-- 打印废弃单 -->
      <el-button size="small" type="primary" @click="abandonedList" v-if="detail.discard_status">
        {{ $t("message.abandonedList") }}
      </el-button>
      <!-- 售中问题提出 -->
      <el-button size="mini" type="primary" @click="issueSubmissionDuringSale" v-if="isAuth(621)">
        {{ $t("message.issueSubmissionDuringSale") }}
      </el-button>
      <!-- 直接付款 1-->
      <el-button size="small" type="primary" class="fr" @click="is0submitOffer(1) && detail.co_porder_sn == ''"
        v-if="isAuth(254) && detail.user.is_pay_authorized" :disabled="!isOffer"
        :title="!isOffer ? '三边有任何一边大于等于60 ，且记抛重量超过30，不能发。' : ''">
        {{ $t("message.directPayments") }}
      </el-button>
      <!-- 给客户报价 0-->
      <el-button size="small" type="primary" class="fr" @click="is0submitOffer(0)"
        v-if="isAuth(254) && detail.co_porder_sn == ''" :disabled="!isOffer"
        :title="!isOffer ? '三边有任何一边大于等于60 ，且记抛重量超过30，不能发。' : ''">
        {{ $t("message.quotationCustomer") }}
      </el-button>
      <!-- 退回给配货 -->
      <el-button size="small" type="success" class="fr dark" @click="backToConfirm" v-if="isAuth(255)">
        {{ $t("message.returnDelivery") }}
      </el-button>
      <!-- 国际运费计算 -->
      <el-button size="small" type="primary" class="secondary fr" @click="InternationalFreight">
        {{ $t("message.internationalFreightCalculation") }}
      </el-button>
      <!-- 发送方式选择 -->
      <el-popover placement="bottom-start" width="200" trigger="click" v-model="visible"
        v-if="isAuth(249) && detail.co_porder_sn == ''">
        <el-select v-model="logistics_id" placeholder="请选择">
          <el-option v-for="item in logisticsList" :key="item.id" :label="item.name" :value="item.id"
            :disabled="item.disabled">
          </el-option>
        </el-select>
        <!-- 确定 -->
        <p style="text-align: center; margin: 20px auto">
          <el-button type="primary" size="mini" @click="updateFreightLogistics">{{ $t("message.ok") }}</el-button>
        </p>
        <el-button size="small" type="primary" class="fr secondary" slot="reference">
          {{ $t("message.sendingModeSelection") }}
        </el-button>
      </el-popover>
      <!-- 箱子拆分到新配送单 -->
      <el-button size="small" type="primary" class="fr secondary" @click="theBoxesAreSplitIntoTheNewDeliveryOrder"
        v-if="isAuth(226)">{{ $t("message.theBoxesAreSplitIntoTheNewDeliveryOrder") }}
      </el-button>
      <!-- Stockcrew 待报价配送单批量上传实际纳品数 -->
      <el-button v-if="isStockcrewSubPorder" size="small" type="primary" class="fr" :loading="deliveryUploading"
        @click="uploadActualDeliveryNumber">
        {{ $t("message.uploadActualDeliveryNumber") }}
      </el-button>

    </div>
    <!--列表  -->
    <div v-show="false">
      <printList ref="printList" />
    </div>
    <!-- 唛头打印 -->
    <div v-show="false">
      <div ref="boxshippingmark" v-if="prinData != false">
        <boxshippingmark :prinData="prinData" />
      </div>
    </div>
    <!-- 装箱打印 -->
    <div v-show="false">
      <div ref="Packinglist">
        <Packinglist :datas="item" v-for="(item, index) in PackingData" :key="index" />
      </div>
    </div>
    <!-- 弹框 -->
    <zDialog ref="dialog" :config="config">
      <el-select v-model="fba_overstep_reason" filterable allow-create default-first-optionplaceholder="请选择"
        style="width: 100%; margin: 50px 0">
        <el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
        </el-option>
      </el-select>
    </zDialog>
    <!-- <el-dialog title="提醒" :visible.sync="dialogVisible" width="30%" center>
     <p>FBA配送单是配货操作提交的，请确认是否有异常。</p>
    </el-dialog> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import printList from "../packing/printList";
import boxshippingmark from "@/components/Printedsheet/boxshippingmark";
import Packinglist from "@/components/Printedsheet/Packinglist";
export default {
  components: {
    printList,
    boxshippingmark,
    Packinglist,
  },
  props: {
    selectedList: { type: Array },
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      prinData: [],
      logistics_id: "",
      visible: false,
      PackingData: [],
      fba_overstep_reason: "",
      dialogVisible: false,
      deliveryUploading: false,
      options: [
        {
          value: " 不良",
        },
        {
          value: " 少货",
        },
        {
          value: " 分批",
        },
        {
          value: " 其他",
        },
        {
          value: " 已收",
        },
      ],
      config: {
        top: "20vh",
        width: "500px",
        autoClose: false,
        // 修改：
        title: "实际贴标数与option数量不符，请填写原因",
        btnTxt: [this.$t("message.confirm"), this.$t("message.cancel")],
      },
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
      logisticsList: (state) => state.porderDetail.logisticsList,
      detail: (state) => state.porderDetail.detail,
      receiver: (state) => state.porderDetail.receiver,
      importer: (state) => state.porderDetail.importer,
      totalShouldPay_JPY: (state) => state.porderDetail.totalShouldPay_JPY,
      boxList: (state) => state.porderDetail.boxList,
      user: (state) => state.porderDetail.user,
      findAllBlockImporterList: (state) => state.porderDetail.findAllBlockImporterList,
      list: (state) => state.porderDetail.list,
    }),
    // 是否可以报价
    isOffer() {
      let isOffer = true
      this.boxList.forEach(item => {
        item.group.forEach(group => {
          if (group.logistics_name == 'EMS') {
            group.list.forEach(list => {
              if ((list.width >= 60 || list.height >= 60 || list.length >= 60) && list.volume_weight >= 30) {
                isOffer = false
              }
            })
          }
        })
      })
      return isOffer
    },
    isStockcrewSubPorder() {
      return this.detail.merge_type === '并单出货·子' &&
        this.detail.external_inbound &&
        this.detail.external_inbound.warehouse_type === 'stockcrew'
    }
  },
  watch: {
    // 千速黑名单
    visible() {
      if (this.visible) {
        let isDisabled = false
        this.findAllBlockImporterList.forEach(item => {
          if (item.importerTel == this.importer.tel) {
            isDisabled = true
          }
        })
        if (isDisabled) {
          this.logisticsList.forEach(item => {
            if (item.id == 18) {
              item.disabled = true
              item.name = item.name + '_(黑名单不可用)'
            }
            if (item.name == 'RW船便') {
              item.name = item.name + '--(仅VIP可使用)'
            }
          })
        }
        this.logisticsList.forEach(item => {
          if (item.name == 'RW船便' || item.name == 'Raku-DQ') {
            item.name = item.name + '--(仅VIP可使用)'
          }
          if (item.name == 'TW船便' && (this.detail.porder_attribute == 'SVIP' || this.detail.porder_attribute == '付费会员')) {
            item.name = item.name + '--(会员客户，建议发RW)'
          }
          if (item.name == '海源DQ船便' && (this.detail.porder_attribute == 'SVIP' || this.detail.porder_attribute == '付费会员')) {
            item.name = item.name + '--(会员客户，建议发RAKU-DQ)'
          }
          if (item.name == 'Rロジ専用船便' && !this.detail.warehouse_inbound_name) {
            item.disabled = true
            item.name = item.name + '--(仅海外仓可使用)'
          }
        })
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.$parent.$refs.getNotice.getNotice(
        this.detail.user_id,
        "业务注意事项"
      );
      this.$parent.$refs.appliedLabels.getList(
        this.detail.list
      );

      this.is0end30();
      this.quantityMismatch()
      this.isForwarding()
    });
    // 


  },
  methods: {
    // 是否是转寄加其他提示
    isForwarding() {
      let flag = false
      let str = ""
      let num = 1
      this.detail.list.forEach(item => {
        if (item.order.type == 2) {
          flag = true
        }
      })
      if (!this.list.every(item => item.inSale == false)) {
        str += `<p>${num}:当前配送单有配送单相关售中问题产品未处理完成，装箱时请注意！！！</p>`
        num++
      }
      // 
      if (this.detail.is_not_fba_submit) {
        str += `<p>${num}:FBA配送单是配货操作提交的，请确认是否有异常。</p>`
        num++
      }
      if (flag) {
        str += `<p>${num}:该配送单里有转寄订单商品，请注意是否有箱子费用需要收取！！</p>`
      }
      if (str) {
        this.$alert(str, '提示', {
          confirmButtonText: '确定',
          center: true,
          dangerouslyUseHTMLString: true,
          callback: action => {
          }
        });
      }
    },
    //装箱数不符
    quantityMismatch() {
      let str = ''
      this.detail.list.forEach((item, index) => {
        if (item.freight_num != item.num) {
          str += `<p> <span style='font-size:20px;font-weight: 600'>NO:${index + 1}</span> ${item.order_sn}番号 <span style='color:#B4272D;font-size:20px;text-align: left;font-weight: 600'>${item.sorting}</span>:提出数与装箱数不一致 </p>`
        }
      })
      if (str) {
        this.$alert(`<div style="max-height:600px; overflow-y: auto;"> ${str}</div> `, '提示', {
          dangerouslyUseHTMLString: true,
          center: true
        });
      }
    },
    is0end30() {
      let str = "";
      this.boxList.forEach((item) => {
        let porder = {
          num0: "",
          num30: "",
        };
        item.group.forEach((group) => {
          group.list.forEach((box) => {
            if (box.weight == 0) {
              porder.num0 += box.number + ",";
            }
            if (box.weight >= 30) {
              porder.num30 += box.number + ",";
            }
          });
        });
        if (porder.num0 != "" || porder.num30 != "") {
          str += `<div style="font-size:20;pxmax-height: 500px;
            overflow-y: auto;">${item.porder_sn}<div>`;
          if (porder.num0 != "") {
            str += porder.num0 + "箱 ，重量为0kg 。<br/>";
          }
          if (porder.num30 != "") {
            str += porder.num30 + "箱 ，单箱重量大于等于30kg。";
          }
        }
      });
      if (str) {
        this.$alert(
          `<div style="color:red;font-size:20px">
       ${str}
        </div>`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            callback: (action) => { },
          }
        );
      }
    },
    //全选
    allChecked() {
      this.$emit("allChecked");
    },
    // 批量同步当前配送单的预计纳品数和实际纳品数
    uploadActualDeliveryNumber() {
      const datas = {
        porder_sn: String(this.porder_sn),
        list: this.list.map(item => ({
          porder_detail_id: String(item.id),
          planned_num: item.planned_num == null ? '' : String(item.planned_num),
          received_num: item.received_num == null ? '' : String(item.received_num),
        })),
      }
      this.deliveryUploading = true
      this.$api.porderApi.updateDelivery(datas).then(res => {
        this.$message.success(res.msg)
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn })
      }).finally(() => {
        this.deliveryUploading = false
      })
    },
    // 箱子拆分到新配送单
    theBoxesAreSplitIntoTheNewDeliveryOrder() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$parent.$refs.offerDistributionOrderSplitting.dialogVisible = true;
    },
    // 批量修改箱子的发送方式
    updateFreightLogistics() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      let max160 = this.isMax160();
      let max30 = this.isMax30();
      if (max30) {
        return this.$alert(`EMS单箱实际重量不能超过30KG`, "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          center: true,
          callback: (action) => { },
        });
      }
      if (max160) {
        this.$alert(`有箱子三边和超过160cm，请注意！`, "物流提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          center: true,
          callback: (action) => {
            if (action == "confirm") {
              // 新物流，海源TK船便，配送单报价时，给箱子选择该物流方式，选海源TK船便的时候
              if (this.logistics_id == 22) {
                this.$alert(
                  `<p style="color:red;font-size:20px">海源TK船便物流只能发关东地区及亚马逊仓库地址，楽天仓库地址，其他地址请与物流确认是否能发，关东地区包含茨城県、栃木県、群馬県、埼玉県、千葉県、東京都、神奈川県，山梨）</p>`,
                  "提示",
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                    center: true,
                    callback: (actions) => {
                      if (actions == "confirm") {
                        this.batchUpdateFreightLogistics();
                      }
                    },
                  }
                );
              } else {
                this.batchUpdateFreightLogistics();
              }
            }
          },
        });
      } else {
        // 新物流，海源TK船便，配送单报价时，给箱子选择该物流方式，选海源TK船便的时候
        if (this.logistics_id == 22) {
          this.$alert(
            `<p style="color:red;font-size:20px">海源TK船便物流只能发关东地区及亚马逊仓库地址，楽天仓库地址，其他地址请与物流确认是否能发，关东地区包含茨城県、栃木県、群馬県、埼玉県、千葉県、東京都、神奈川県，山梨）</p>`,
            "提示",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              center: true,
              callback: (actions) => {
                if (actions == "confirm") {
                  this.batchUpdateFreightLogistics();
                }
              },
            }
          );
        } else {
          this.batchUpdateFreightLogistics();
        }
      }
    },
    // 批量修改箱子的发送方式
    batchUpdateFreightLogistics() {
      let datas = {
        logistics_id: this.logistics_id,
        freight_id_set: this.boxIds,
      };
      let data = {
        porder_sn: this.porder_sn,
      };
      this.$api.porderApi.batchUpdateFreightLogistics(datas).then((res) => {
        this.$message.success(res.msg);
        this.visible = false;
        this.logistics_id = "";

        // 先刷新箱子
        this.$api.porderApi.freightList(data).then((res) => {
          this.$store.commit("setFreightList", res.data);
          // 查看有没有偏远费，超大件费用，
          this.$api.porderApi.porderAmountCurrent(data).then((res) => {
            let list = [];
            res.data.logisticsFeePart.forEach((item) => {
              item.extra_money.forEach((items) => {
                if (items.extra_fee_rmb > 0) {
                  items.logistics_id = item.logistics_id;
                  items.freight_id = this.getLogisticsFreight_id(
                    item.logistics_id
                  );
                  list.push(items);
                }
              });
            });
            // 有偏远费，超大件费用 新增其他费用
            this.detail.other_price_list = [];
            list.forEach((item) => {
              this.detail.other_price_list.push({
                porder_sn: this.porder_sn,
                logistics_id: item.logistics_id,
                type: 1,
                desc: item.extra_fee_name,
                fee: item.extra_fee_rmb,
                freight_id: item.freight_id,
              });
            });
            let porderOtherFeeData = {
              porder_sn: this.porder_sn,
              list:
                this.detail.other_price_list != false
                  ? this.detail.other_price_list
                  : "",
              logisticsData: res.data,
            };
            this.$api.porderApi
              .setPorderOtherFee(porderOtherFeeData)
              .then((res) => {
                this.$message.success(res.msg);
                this.$store.dispatch("porderDetail", data);
              });

            // 刷新配送单跟箱子详情
            this.$store.commit("setBoxIds", []);
          });
        });
        // 检查偏远费
        this.checkSpecialAddress();
      });
    },
    //查询物流方式第一箱ID
    getLogisticsFreight_id(logistics_id) {
      let freight_id = "";
      this.boxList.forEach((item) => {
        item.group.forEach((group) => {
          if (group.logistics_id == logistics_id) {
            freight_id = group.list[0].id;
          }
        });
      });
      return freight_id;
    },
    // tw是否大于箱规三边和超过160cm时
    isMax160() {
      let flag = false;
      // 定义需要检查的物流ID常量
      const SIZE_CHECK_LOGISTICS_IDS = [12, 18, 2, 20, 15, 23, 24, 25];
      for (let i = 0; i < this.boxList.length; i++) {
        this.boxList[i].group.forEach((item) => {
          if (SIZE_CHECK_LOGISTICS_IDS.includes(this.logistics_id)) {
            let max160 = 0;
            item.list.forEach((items) => {
              if (items.checked) {
                max160 = items.height + items.width + items.length;
                if (max160 > 160) {
                  flag = true;
                }
              }
            });
          }
        });
      }
      return flag;
    },
    //EMS单箱 ，实际重量超过30KG 的
    isMax30() {
      let flag = false;
      for (let i = 0; i < this.boxList.length; i++) {
        this.boxList[i].group.forEach((item) => {
          if (this.logistics_id == 1) {
            item.list.forEach((items) => {
              if (items.checked) {
                if (items.weight > 30) {
                  flag = true;
                }
              }
            });
          }
        });
      }
      return flag;
    },
    // 检查偏远费
    checkSpecialAddress() {
      let datas = {
        porder_sn: this.porder_sn,
      };
      this.$api.porderApi.checkSpecialAddress(datas).then((res) => {
        if (res.data.is_special) {
          this.$alert(
            `<p style="color:red;font-size:20px">当前地址邮编匹配属于(${res.data.special_address})，有可能会产生偏远费用，报价时请注意该物流对于该地区是否有偏远费用！！！
          下面物流部分地区包含部分偏远收费：<br/> 
          1.KS-JP （沖縄・北海道・鹿児島）<br/> 
          2.电子特殊便（沖縄・北海道・鹿児島）<br/> 
          3.DQ船便  （遠隔地費用あり）<br/> 
          4.TW船便 （遠隔地費用あり）<br/> 
          5.OCS（冲绳）
            </p>
            `,
            "提示",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              callback: (action) => {
                let checkSpecialAddress = localStorage.getItem(
                  "checkSpecialAddress"
                )
                  ? JSON.parse(localStorage.getItem("checkSpecialAddress"))
                  : [];
                checkSpecialAddress.push(this.porder_sn);
                localStorage.setItem(
                  "checkSpecialAddress",
                  JSON.stringify(checkSpecialAddress)
                );
              },
            }
          );
        }
      });
    },
    // 国际物流计算
    InternationalFreight() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$parent.$refs.InternationalFreight.dialogVisible = true;
    },
    //退回给配货
    backToConfirm() {
      this.$confirm(
        this.$t("message.isReturnDelivery"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi
            .backToConfirm({ porder_sn: this.porder_sn })
            .then((res) => {
              this.$message.success(res.msg);
              this.$store.dispatch("porderDetail", {
                porder_sn: this.porder_sn,
              });
              this.$store.commit("setBoxIds", []);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // STOCKCREW 关联配送单报价前校验箱数及物流信息。
    checkStockcrewExternalInbound() {
      if (this.detail.external_inbound == null) return ''

      let boxCount = 0
      const expressNoSet = new Set()
      const logisticsIdSet = new Set()
      this.boxList.forEach((item) => {
        item.group.forEach((group) => {
          if (group.logistics_id !== null && group.logistics_id !== '') {
            logisticsIdSet.add(group.logistics_id)
          }
          group.list.forEach((box) => {
            boxCount++
            if (box.express_no) expressNoSet.add(String(box.express_no).trim())
          })
        })
      })

      if (boxCount > 100) {
        return '此配送单为STOCKCREW订单，当前配送单需要拆单。<br>单个配送单大于100箱。'
      }
      if (expressNoSet.size > 1 || logisticsIdSet.size > 1) {
        return '此配送单为STOCKCREW订单，当前配送单需要拆单。<br>配送单存在多个物流号或者物流方式。'
      }
      return ''
    },
    // 是否0配送费报价
    is0submitOffer(type) {
      const stockcrewMessage = this.checkStockcrewExternalInbound()
      if (stockcrewMessage) {
        this.$alert(stockcrewMessage, 'STOCKCREW仓库配送单提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          center: true,
        })
        return false
      }
      let str = this.checkActualReceivedNum()
      if (str) {
        this.$alert(
          `${str}`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            center: true,
            callback: (action) => {

            },
          }
        );
        return false;
      }
      if (this.detail.logistics_price == 0) {
        this.$alert(
          `<p style="color:red;font-size:20px">配送单总运费是0的</p>`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            center: true,
            callback: (action) => {
              if (action == "confirm") {
                this.rquotationCustomer(type);
              }
            },
          }
        );
      } else {
        this.rquotationCustomer(type);
      }
    },
    // 报价
    rquotationCustomer(type) {
      let FBAnum = 0;
      this.detail.list.forEach((item) => {
        item.option.forEach((opti) => {
          if (opti.name == "FBA贴标") {
            FBAnum += opti.num - 0;
          }
        });
      });
      // console.log(this.detail.fba_complete_num, FBAnum);
      if (this.detail.fba_complete_num > FBAnum) {
        this.$refs.dialog.open("", () => {
          this.submitOffer(type);
        });
      } else {
        this.submitOffer(type);
      }
    },
    //提交报价
    submitOffer(type) {
      let datas = {
        porder_sn: this.porder_sn,
        y_remark: this.detail.porder_remark.client_remark_translate,
        list: [],
        logistics_price_artificial: this.detail.logistics_price,
        fba_complete_num: this.detail.fba_complete_num,
        fba_overstep_reason: this.fba_overstep_reason,
      };
      this.detail.list.forEach((item) => {
        datas.list.push({
          id: item.id,
          y_remark: item.y_remark,
          received_num: item.received_num,
        });
      });

      if (this.importer.id == undefined) {
        this.$alert(
          "进口商信息氏名,住所,郵便,携帯番号为必填.请点击编辑修改后确定再进行报价",
          "提示",
          {
            confirmButtonText: "确定",
            center: true,
          }
        );
        return false;
      }
      if (!this.receiver.id) {
        this.$alert(
          "收件人信息氏名,住所,郵便,携帯番号为必填.请点击编辑修改后确定再进行报价",
          "提示",
          {
            confirmButtonText: "确定",
            center: true,
          }
        );
        return false;
      }

      if (type == 0) {
        this.$confirm(
          this.$t("message.isQuotationCustomer"),
          this.$t("message.hint"),
          {
            confirmButtonText: this.$t("message.ok"), //确定
            cancelButtonText: this.$t("message.cancel"), //取消
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$api.porderApi.submitOffer(datas).then((res) => {
              this.$message.success(res.msg);
              setTimeout(() => {
                window.open("about:blank", "_top").close();
              }, 1000);
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      } else {
        this.balancePayPorder(datas);
      }
    },
    // 配送单付款
    balancePayPorder(data) {
      let datas = {
        porder_sn: this.porder_sn,
        user_id: this.detail.user_id,
        discounts_id: "",
      };
      this.$alert(
        `<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance
        }</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - this.totalShouldPay_JPY
        }</b></p>
      <p> ${this.$t("message.whetherToConfirmDirectPayment")}</p>`,
        "直接付款",
        {
          confirmButtonText: "确定",
          center: true,
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            if (action == "confirm") {
              this.$api.porderApi.submitOffer(data).then((res) => {
                this.$api.clienteleApi.balancePayPorder(datas).then((res) => {
                  this.$message.success(res.msg);
                  setTimeout(() => {
                    window.open("about:blank", "_top").close();
                  }, 1000);
                });
              });
            }
          },
        }
      );
    },
    // 打印清单
    printList() {
      this.$nextTick(() => {
        this.$print(this.$refs.printList);
      });
    },
    //配货打印唛头
    shippingMarkForDistribution() {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$api.getMaitouData({ freightIds: this.boxIds, not_print: 1 }).then((res) => {
        res.data.forEach((item) => {
          item.boxTotal = this.boxIds.length;
        });
        this.prinData = res.data;
        this.$nextTick(() => {
          this.$print(this.$refs.boxshippingmark);
          this.prinData = [];
        });
      });
    },
    //打印装箱单
    printPackingList(type) {
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$api.porderApi
        .boxDetailBatchPrint({ freight_id_set: this.boxIds })
        .then((res) => {
          res.data.forEach((item) => {
            item.total = 0;
            item.porder_freight_detail.forEach((items) => {
              item.total += items.num;
              if (type) {
                items.order_detail.confirm_price = "";
              }
            });
          });
          this.PackingData = res.data;
          this.$nextTick(() => {
            this.$print(this.$refs.Packinglist);
          });
        });
    },
    //打印废弃单
    abandonedList() {
      let boxIds = []
      this.boxList.forEach(item => {
        item.group.forEach(items => {
          items.list.forEach(box => {
            boxIds.push(box.id);
          })
        })
      })
      this.$api.porderApi.discardList({ porder_sn: this.porder_sn }).then(res => {
        let itemData = res.data.data[0]
        this.$api.getMaitouData({ freightIds: boxIds }).then((res) => {
          res.data.forEach((item) => {
            item.boxTotal = boxIds.length;
            item.reason = itemData.reason
            item.created_at = itemData.created_at
            item.abandon = itemData.abandon_type == 1 ? '客户要求废弃' : '联系不上超时废弃'
            // 二维码
            this.$QRCode.toDataURL(
              item.encrypt_freight_id,
              { errorCorrectionLevel: "L", margin: 2, width: 128 },
              (err, url) => {
                if (err) throw err;
                item.QRImgUrl = url;
              }
            );
          });
          let datas = {
            logistics: '废弃',
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.$store.commit('setPrintData', datas)
          this.$nextTick(() => {
            this.$print(this.$parent.$refs.abandoned);
            this.$store.commit('setPrintData', {})
          });
        });
      })
    },
    //售中问题提出
    issueSubmissionDuringSale() {
      if (this.selectedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let ids = []
      this.selectedList.forEach(item => {
        ids.push(item.order_detail_id)
      })
      this.$parent.$refs.inSalePreview.storePreview(ids)
    },
    //实际纳品数必填
    checkActualReceivedNum() {
      let str = ''
      if (this.detail.is_amazon) {
        this.list.forEach(item => {
          if (item.received_num === '' && item.porder_detail_tag != false) {
            str += `${item.order_sn}-${item.sorting}番实际纳品数不能为空\n`
          }
        })
      }
      return str
    },
  },
};
</script>
<style lang="scss" scoped>
.operate {

  margin: 0 24px;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;
  overflow: hidden;
  line-height: 32px;

  .el-button {
    margin-left: 30px;
  }
}

/deep/.el-dialog__wrapper {
  z-index: 999999 !important;
}
</style>
